import React, { Component } from "react";
import { Col, Button, Row } from "react-bootstrap";
import RepairServices from "./images/newImages/Depot Electronics.jpg";
import TechSupport from "./images/techSupport.JPG";
import MotorShield from "./images/Genius_614_No_Background_Shadow_Added.png";
import CleaningService from "./images/RevisedImages/CalibrationLabUnstretched.jpg";
import SurdialDXAlt from "./images/SURDIAL_DX_Training_Mathew_Group_Edited_10152024_Cropped.jpg";
import Manufacturing from "./images/Manufacturing.jpg";
import CardioQuip from "./images/hsm-revisions/Quality.jpg";
import SURDIALDXHemodialysisSystemTreatment from "./images/surdialDX/SURDIALDXHemodialysisSystemTreatment.jpg";

class LandingCardsD extends Component {
  render() {
    return (
      <Col lg={12}>
        <Row className="equal">
          <Col md={4} lg={4} className="LandingCardsCol">
            <h5>Hemodialysis&nbsp;Parts&nbsp;Service&nbsp;Center</h5>

            <div className="containingDivLandingD">
              <img
                src={RepairServices}
                className="landingCardDImg"
                alt="Repair Services"
              />
              <i className="arrow up" />

              <div className="cardOverlay">
                <div className="landingCardDText">
                  <br />
                  <p>
                  NIPRO Technical Solutions offers a quick
                    turnaround time along with our signature 6-month, hassle-free warranty policy for all services.
                  </p>
                  <Button variant="custom">
                    <a class="styledLink" href="/services">Learn More</a>
                  </Button>
                </div>
              </div>
            </div>
          </Col>

          <Col md={4} lg={4} className="LandingCardsCol">
            <h5>Calibration Service Center & Reference Meters</h5>

            <div className="containingDivLandingD">
              <img
                src={CleaningService}
                className="landingCardDImg"
                alt="Calibration Solutions"
              />
              <i className="arrow up" />

              <div className="cardOverlay">
                <div className="landingCardDText">
                  <br />
                  <p>
 NIPRO Technical Solutions' full-service calibration center provides verification 
 and repair services for a wide range of multimeters, safety analyzers, and biomedical reference meters.
                  </p>
                  <Button variant="custom">
                    <a class="styledLink" href="/meters-calibration">Learn More</a>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} lg={4} className="LandingCardsCol">
            <h5>
          Biomedical&nbsp;Technician&nbsp;Assist&nbsp;Devices
            </h5>

            <div className="containingDivLandingD">
              <img
                src={MotorShield}
                className="landingCardDImg"
                alt="H&S Motor Shield"
              />
              <i className="arrow up" />

              <div className="cardOverlay">
                <div className="landingCardDText">
                  <br />
                  <p>
                  NIPRO Technical Solutions is dedicated to helping
                    biomed technicians through innovative products such as the
                    Genius 614 Valve & Chamber Analyzer, BTA-612 Selectable
                    Voltage Power Supply, Motor Shields & Valve Repair Kits.
                  </p>
                  <Button variant="custom">
                    <a class="styledLink" href="/products">Learn More</a>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="equal">
          <Col md={4} lg={4} className="LandingCardsCol">
            <h5>Technical Support</h5>
            <div className="containingDivLandingD">
              <img
                src={TechSupport}
                className="landingCardDImg"
                alt="Tech Support Team"
              />
              <i className="arrow up" />

              <div className="cardOverlay">
                <div className="landingCardDText">
                  <br />
                  <p>
                    Speak with a highly skilled Technical Support expert to
                    answer all your troubleshooting questions. All calls are
                    answered by our friendly customer service representatives.
                  </p>
                  <Button variant="custom">
                    <a class="styledLink" href="/technical-support">Learn More</a>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} lg={4} className="LandingCardsCol">
            <h5>Field&nbsp;Service&nbsp;Engineering</h5>
            <div className="containingDivLandingD">
              <img
                src={SurdialDXAlt}
                className="landingCardDImg"
                alt="Surdial DX Engineering"
              />
              <i className="arrow up" />

              <div className="cardOverlay">
                <div className="landingCardDText">
                  <br />
                  <p>
                      NIPRO Technical Solutions performs repairs, annual maintenance, 
                      and expert support for all major U.S. brands of hemodialysis machines. {" "}
                  </p>
                  <Button variant="custom">
                    <a class="styledLink" href="/field-service-engineering">Learn More</a>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} lg={4} className="LandingCardsCol">
            <h5>SURDIAL™ DX Hemodialysis System</h5>
            <div className="containingDivLandingD">
              <img
                src={SURDIALDXHemodialysisSystemTreatment}
                className="landingCardDImg"
                alt="SDX"
              />
              <i className="arrow up" />

              <div className="cardOverlay">
                <div className="landingCardDText">
                  <br />
                  <p>
The SURDIAL™ DX Hemodialysis System was inspired by clinical needs, patient comfort, and operational efficiency. 
Its innovative design takes both the patient and clinician experience to a different level.
                  </p>
                  <Button variant="custom">
                    <a class="styledLink" href="surdialDX">Learn More</a>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="equal">
          <Col md={4} lg={4} className="LandingCardsCol">
            <h5>Manufacturing&nbsp;Services</h5>
            <div className="containingDivLandingD">
              <img
                src={Manufacturing}
                className="landingCardDImg"
                alt="Manufacturing"
              />
              <i className="arrow up" />

              <div className="cardOverlay">
                <div className="landingCardDText">
                  <br />
                  <p>
                    Our Manufacturing Service Center provides dedicated and customizable
                    manufacturing services for the global medical community.
                  </p>
                  <Button variant="custom">
                    <a class="styledLink" href="manufacturing/manufacturing-services">Learn More</a>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} lg={4} className="LandingCardsCol">
                      <h4>
                        Quality Systems
                      </h4>
          
                      <div className="containingDivLandingD">
                        <img
                          src={CardioQuip}
                          className="landingCardDImg"
                          alt="Quality Servcice Engineer"
                        />
                        <i className="arrow up" />
          
                        <div className="cardOverlay">
                          <div className="landingCardDText">
                            <br />
                            <p>
                              At NIPRO Technical Solutions, quality is
                              ingrained into who we are. Let us use our over 25 years of experience
                              to seamlessly develop a quality system for you.
                            </p>
                            <Button variant="custom">
                              <a class="styledLink" href="/quality-systems">Learn More</a>
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Col>        
        </Row>
      </Col>
    );
  }
}

export default LandingCardsD;
